<!--自定义表头显示  -->
<template>
	<div class="dialogBox">
		<el-dialog title="补录回单" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="350px" :before-close="cancle">
			<div class="mt10">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top"  class="demo-ruleForm">
					<el-form-item label="回单编号" prop="agentVoucher">
						<el-input v-model.trim="ruleForm.agentVoucher"  placeholder="请输入回单编号"  maxlength="20" >
						</el-input>
					</el-form-item>
				</el-form>				
			</div>

			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				ruleForm:{
					orderId:"",
					agentVoucher:""
				},
				rules:{
					agentVoucher: [{
						required: true,
						message: '请输入回单编号',
						// trigger: 'change'
					},
					{
							pattern: /^[0-9A-Z]+$/,
							message: '只能输入数字和大写字母',
					} 
					],
				}
			}
		},
		created() {

		},
		methods: {
			init(orderId,agentVoucher) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.ruleForm.orderId=orderId?orderId:''
					this.ruleForm.agentVoucher=agentVoucher?agentVoucher:''
					
				})
			},
			
			// 获取列表
			submitForm: debounce(function () {
				let that = this;
					that.$refs['ruleForm'].validate((valid) => {
					if (valid) {
					that.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
					}).then(() => {
			          that.$request.post(
							"addVoucher",
							true, {
								orderId: that.ruleForm.orderId,
								agentVoucher: that.ruleForm.agentVoucher
							}
						)
						.then((res) => {
							if (res) {
									that.$message({
										type: 'success',
										message: '补录成功！ '
									});
									this.dialogVisible = false
									this.$emit("getInfo")
							}
						})
						}).catch(() => {});
					} else {
						return false;
					}
						});
				}, 1000, true),

		
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 10px 20px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}



	.w225 {
		width: 225px;
	}

	.sort-box {
		justify-content: center;
		line-height: 40px;
		font-size: 16px;
	}
	
		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 5px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
		}

</style>
